import { Region } from '@lemon8/web-app-shared/i18n';
import { $LegalRegion } from 'shared/atoms';
import { useAtomValue } from 'jotai';
import { Select } from '../select';
import switchRegion from '~/utils/switch-region';

import './style.scss';

type TSwitchLegalRegionProps = {
  className?: string;
};

export const LegalRegionSwitcher = (props: TSwitchLegalRegionProps): JSX.Element => {
  const { className } = props;

  const { region: curRegion } = useAtomValue($LegalRegion);

  const handleRegionSwitch = (value: Region) => {
    switchRegion({ region: value });
  };

  return (
    <div className={[className, 'region-switcher-wrapper'].join(' ')}>
      <Select value={curRegion} showMask={false} onChange={handleRegionSwitch}>
        <Select.Option value={Region.jp} key="1">
          日本
        </Select.Option>
        <Select.Option value={Region.th} key="2">
          ไทย
        </Select.Option>
        <Select.Option value={Region.id} key="3">
          Indonesia
        </Select.Option>
        <Select.Option value={Region.vn} key="5">
          Việt Nam
        </Select.Option>
        <Select.Option value={Region.my} key="6">
          Malaysia
        </Select.Option>
        <Select.Option value={Region.sg} key="7">
          Singapore
        </Select.Option>
        <Select.Option value={Region.us} key="8">
          US
        </Select.Option>
        <Select.Option value={Region.ca} key="9">
          Canada
        </Select.Option>
        <Select.Option value={Region.nz} key="10">
          New Zealand
        </Select.Option>
        <Select.Option value={Region.au} key="11">
          Australia
        </Select.Option>
      </Select>
    </div>
  );
};
